// We want this component to never update to make sure that the modifications by the 3rd party

import React from "react"

// script are not overwritten.
const HubspotFormEmbed = React.memo(({ params }) => {
  React.useEffect(() => {
    const script = document.createElement("script")
    script.src = "//js.hsforms.net/forms/v2.js"
    script.id = "hubspotForms"
    script.onload = () => {
      window.hbspt.forms.create({
        ...params,
        target: "#hubspot-form-container",
      })
    }
    document.body.appendChild(script)
  })
  return (
    <div className="ext-iframe-container">
      <div className="hubspot-form" id="hubspot-form-container" />
    </div>
  )
})

export default HubspotFormEmbed
